<template>
  <n-button v-bind="getBindValue">
    <template #icon>
      <slot name="icon"></slot>
    </template>
    <slot></slot>
  </n-button>
</template>

<script setup lang="ts">
  import { NButton } from 'naive-ui';
  import { computed } from 'vue';
  import { buttonProps } from './props';

  const props = defineProps(buttonProps);
  const getBindValue = computed(() => props);
</script>
